const apiUrl = process.env.REACT_APP_API_URL;

module.exports = {

  GET_ALL_USERS: `${apiUrl}/api/dms/User/GetUsers`,

  //Notification
  GET_NOTIFICATION : `${apiUrl}/api/dms/Notification/GetUnReadNotification`,
  GET_NOTIFICATION_COUNT : `${apiUrl}/api/dms/Notification/GetUnReadNotificationCount`,
  PUT_UPDATE_NOTIFICATION : `${apiUrl}/api/dms/Notification/UpdateWebNotificationStatus`,
  
  
  //Favorite Module
  GET_ALL_FAVORITES: `${apiUrl}/api/dms/Favourite/GetFavouriteDocuments`,
  DELETE_FAVORITES: `${apiUrl}/api/dms/Favourite/RemoveFromFavourites`,

  //Properties
  GET_PROPERTIES: `${apiUrl}/api/dms/Document/GetDocumentById`,

  //VersionLog
  GET_VERSION_LOG: `${apiUrl}/api/dms/Log/GetVersionHistory`,
 
  //User login
  GET_USER: `${apiUrl}/api/dms/User/GetUserByEmail`,

  //HISTORY_LOG
  GET_HISTORY_LOG:`${apiUrl}/api/dms/Log/GetHistoryLog`,

  //PendingTask Module
  GET_ALL_PENDINGTASKS: `${apiUrl}/api/dms/Document/PendingDocuments`,
  GET_PENDINGTASKS_COUNT:`${apiUrl}/api/dms/Document/PendingDocumentsCount`,
  PUT_APPROVER_DOCUMENT: `${apiUrl}/api/dms/Document/ApproveDocument`,
  PUT_SENDBACKDOCUMENT: `${apiUrl}/api/dms/Document/SendbackDocument`,
  GET_REVIEWERDATA:`${apiUrl}/api/dms/MasterData/GetReviewers`,
  SAVE_RENEW_DOCUMENT :`${apiUrl}/api/dms/Document/RenewDocument`,
  SAVE_ARCHIVE_DOCUMENT :`${apiUrl}/api/dms/Document/ArchiveDocument`,
  SAVE_OBSOLETE_DOCUMENT :`${apiUrl}/api/dms/Document/ObsoleteDocument`,
  SAVE_RESUBMIT_DOCUMENT :`${apiUrl}/api/dms/Document/UpdateDocument`,
  POST_REVIEWER_DOCUMENT:`${apiUrl}/api/dms/Document/UpdateDocumentReviewer`,
  POST_INACTIVE_REVIEWER_DOCUMENT:`${apiUrl}/api/dms/Document/UpdateInactiveDocumentReviewer`,

  //GET FILES
  GET_PARTICULAR_FILE_URL:`${apiUrl}/api/dms/File/GetFileById`,

  //GET FILE URLS
  GET_ALL_FILES_URL:`${apiUrl}/api/dms/File/GetFiles`,

  //Document migration
  POST_UPLOAD_DOCUMENTS:`${apiUrl}/api/dms/File/UploadDocument`,

  //COMMON SEARCH
  GET_SEARCH_DETAILS: `${apiUrl}/api/dms/Document/SearchDocuments`,

  //CANCEL_REQUEST
  CANCEL_REQUEST:`${apiUrl}/api/dms/Document/CancelRequest`,
  SUBMIT_REQUESTS:`${apiUrl}/api/dms/Document/UpdateDocument`,
  UNOBSOLETE_REQUESTS:`${apiUrl}/api/dms/Document/UnObsoleteDocument`,

  //Users
  GET_USER_LIST:`${apiUrl}/api/dms/MasterData/GetReviewers`,

  //MYREQUEST MODULE
  GET_MYREQUESTS:`${apiUrl}/api/dms/Document/MyCompletedTasks`,
  GET_MY_COMPLETED_TASK_PROPERTIES:`${apiUrl}/api/dms/Document/GetDocumentById`,


  //GET_CATEGORY2
  GET_CATAGORY2:`${apiUrl}/api/dms/Category/GetCategories`,
  GET_CATAGORY2_LIST:`${apiUrl}/api/dms/category/getcategory2`,


 //MASTERDATA
 EXIST_CATEGORYNAME:`${apiUrl}/api/dms/Category/IsCategoryPresent`,

  //GET FILES
  GET_ALL_FILES: `${apiUrl}/api/dms/Document/GetFiles`,

  //GET FILE URLS
  // GET_ALL_FILES_URL:`${apiUrl}/api/dms/Document/GetFileById`,

  //COMMON SEARCH
  POST_SEARCH_DETAILS: `${apiUrl}/api/dms/Document/SearchDocuments`,
  GET_FILE_TYPE: `${apiUrl}/api/dms/MasterData/GetFileType`,


 //MASTERDATA
 GET_MASTERDATA:`${apiUrl}/api/dms/MasterData/GetMasterData`,
 GET_PARDICULAR_RECORD:`${apiUrl}/api/dms/Category/GetCategoryById`,
 POST_MASTERDATA:`${apiUrl}/api/dms/Category/AddCategories`,
 PUT_MASTERDATA:`${apiUrl}/api/dms/Category/UpdateCategories`,
 DELETE_MASTERDATA:`${apiUrl}/api/dms/Category/RemoveCategories`,
 GET_CATAGORY_DROPDOWN:`${apiUrl}/api/dms/MasterData/GetCategoryMasterData`,
 IS_DOCUMENT_PRESENT_CAT:`${apiUrl}/api/dms/MasterData/IsDocumentPresent`,
 GET_REVIEWERS:`${apiUrl}/api/dms/MasterData/GetReviewers`,
 GET_STATUS:`${apiUrl}/api/dms/MasterData/GetStatus`,
 GET_DOCUMENTFORMAT:`${apiUrl}/api/dms/MasterData/GetDocumentFormat`,



 //LEDGER MODULE
 GET_LEDGER:`${apiUrl}/api/dms/Ledger/GetLedger`,
 GET_PARTICULAR_LEDGER:`${apiUrl}/api/dms/Ledger/GetLedgerById`,
 POST_LEDGER:`${apiUrl}/api/dms/Ledger/AddLedger`,
 PUT_LEDGER:`${apiUrl}/api/dms/Ledger/UpdateLedger`,
 DELETE_LEDGER:`${apiUrl}/api/dms/Ledger/RemoveLedger`,
 EXIST_DOCUMENT_NUMBER_FORMAT:`${apiUrl}/api/dms/MasterData/IsDocumentFormatPresent`,



 //NOTIFICATION PERIOD MODULE
 GET_NOTIFICATION_PERIOD:`${apiUrl}/api/dms/MasterData/GetExpiryPeriod`,
 PUT_NOTIFICATION_PERIOD:`${apiUrl}/api/dms/MasterData/UpdateExpiryPeriod`,

//Download Files
SINGLE_FILE_DOWNLOAD:`${apiUrl}/api/dms/File/DownloadFileById`,
MULTIPLE_FILES_DOWNLOAD:`${apiUrl}/api/dms/File/DownloadMultipleFile`,


  //UPLOAD FILES
  POST_UPLOAD_FILES:`${apiUrl}/api/dms/File/uploadfiles`,

  //Documents
   POST_CATEGORIES:`${apiUrl}/api/dms/Category/GetCategories`,
   POST_DOCUMENTS:`${apiUrl}/api/dms/Document/GetDocuments`,
   PUT_ARCHIVE:`${apiUrl}/api/dms/Document/ArchiveDocument`,
   PUT_OBSOLETE:`${apiUrl}/api/dms/Document/ObsoleteDocument`,
   PUT_UNOBSOLETE:`${apiUrl}/api/dms/Document/UnObsoleteDocument`,
   GET_DOCUMENT_PROPERTIES:`${apiUrl}/api/dms/Document/GetDocumentProperties`,
   GET_CATEGORY_BY_ID:`${apiUrl}/api/dms/Category/GetCategoryById`,
   POST_ADD_FAVOURITES:`${apiUrl}/api/dms/Favourite/AddToFavourites`,
   POST_GET_FILES:`${apiUrl}/api/dms/File/GetFiles`,
   GET_FILES_URL:`${apiUrl}/api/dms/File/GetFileById`,
   POST_RENEW_DOCUMENT:`${apiUrl}/api/dms/Document/RenewDocument`,
   POST_NEW_DOCUMENT:`${apiUrl}/api/dms/MasterData/GetDocumentFormat`,
   POST_REGISTER_DOCUMENT:`${apiUrl}/api/dms/Document/RegisterDocument`,
   GET_DOWNLOAD_FILE : `${apiUrl}/api/dms/File/DownloadFileById`,
   POST_DOWNLOAD_MULTIPLE_FILE : `${apiUrl}/api/dms/File/DownloadMultipleFile`,
   GET_DOCUMENT_BY_ID:`${apiUrl}/api/dms/Document/GetDocumentById`,
   POST_VALIDATE_DOCUMENT_PASSWORD: `${apiUrl}/api/dms/Document/ValidateDocumentPassword`,
   POST_UPDATE_DOC_PASSWORD: `${apiUrl}/api/dms/Document/UpdateDocumentPassowrd`,

   //Google Logout api
   PUT_AUTHENTICATE:`${apiUrl}/api/dms/Authentication/token`,
   PUT_INVALID_TOKEN:`${apiUrl}/api/dms/Authentication/invalidate-token`,
};
